








































































import Vue from 'vue';
import AuthService from '@/services/auth/AuthService';
import camelcaseKeysDeep from 'camelcase-keys-deep';
import AuthLoginResponse from '@/datatypes/auth/auth-login-response';
import AuthTwoFactorTokenRequest from '@/datatypes/auth/auth-two-factor-token-request';

export default Vue.extend({
  data: () => ({
    email: '',
    password: '',
    authService: new AuthService(),
    secondFactorRequest: new AuthTwoFactorTokenRequest({}),
    requiresSecondFactor: false,
  }),

  mounted() {
    this.mountedEvent();
  },

  methods: {
    mountedEvent() {
      const emailRef = this.$refs.email as HTMLFormElement;

      emailRef.$el.focus();
      if (this.authService.logged()) {
        this.$router.push('/');
      }
    },

    login() {
      this.authService.login(this.email, this.password).then((response) => {
        const responseData = new AuthLoginResponse(camelcaseKeysDeep(response.data));

        if (responseData.smsProtect) {
          this.requiresSecondFactor = true;

          this.secondFactorRequest.key = responseData.challenge;
          this.secondFactorRequest.secret = responseData.secret;

          this.$store.commit('errorMessage', 'SMS with the second factor token sent.');
        } else {
          this.$store.commit('login');

          this.$router.push('/');
        }
      }).catch((error) => {
        this.$snackbar.message(error.response.data.message);
      });
    },

    submitToken() {
      this.authService.loginToken(this.secondFactorRequest).then(() => {
        this.$store.commit('login');

        this.$router.push('/');
      }).catch((error) => {
        this.$snackbar.message(error.response.data.message);
      });
    },
  },
});
